class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/sessions`;
    }
    /**
     * Returns the list of historical Webinar Sessions hosted by a current authorized user
     * sorted by 'endTime' in the descending order. Depending on a session status 'endTime' can
     * represent actual end time or scheduled end time.
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/sessions
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
